<template lang="pug">
  el-card.box-processo(shadow="hover")
    h1.titulo(v-if="!processo") Buscar Processo
    div.box-titulo(v-else)
      el-button.botao-voltar(
        type="primary"
        @click="voltar"
      )
        span.center
          i.fas.fa-chevron-left
      span.span-titulo(v-if="processo") {{ `Processo ${numProcesso}:` }}
    el-row.caixa-pesquisa(:gutter="30", v-if="!processo")
      el-col(:span="8")
        app-label(label="Digite o N° do Processo:")
        el-input(
          placeholder="N° do Processo",
          class="input-with-select",
          v-model="numProcesso"
        )
          el-button.color-default(
            slot="append",
            icon="el-icon-search",
            id='botao-pesquisar',
            @click="pesquisar"
          )
    el-row.caixa-pesquisa(:gutter="30", v-else)
        card-processo(
          :idProcesso="processo.id",
          :nomeInteressado="processo.nomeRazaoSocialInteressado",
          :statusProcesso="processo.status",
          :numeroProcesso="processo.numeroProcesso",
          :cpfCnpjInteressado="processo.cpfCnpjInteressado",
          :setorProcesso="processo.setor",
          :opcoesAcoes="false",
          :numeroProtocolo="processo.numeroProtocolo",
          :tipoCodigoProcesso="processo.tipo.codigo",
          :usuario="processo.usuario"
        )
    .full-width
    .comunicacao-main
      .listagem-conversas
        listagem-conversas(
          :conversas="conversas",
          @conversaEncerrada="pesquisarComProcesso"
        )
      app-paginacao(
        :total="totalConversas",
        :pagina="paginaFiltro.pagina + 1",
        :tamanhoPagina="paginaFiltro.tamanhoPagina",
        @changePage="changePage"
      )
</template>

<script>
import AppLabel from '@/components/AppLabel'
import { buscarProcesso } from '@/utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CardProcesso from './components/CardProcesso.vue'
import ListagemConversas from './ListagemConversa.vue'
import AppPaginacao from '../../components/AppPaginacao.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    AppLabel,
    CardProcesso,
    ListagemConversas,
    AppPaginacao
  },
  data () {
    return {
      numProcesso: '',
      processo: null,
      conversas: [],
      loading: false,
      paginaFiltro: {
        pagina: 0,
        tamanhoPagina: 15
      },
      totalConversas: 0,
      filtroPesquisa: {}
    }
  },

  mixins: [
    AppNotificacao
  ],

  methods: {
    async pesquisar () {
      if (!this.numProcesso || this.numProcesso === '') {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha o campo N° do Processo')
      } else {
        try {
          const response = await buscarProcesso(this.numProcesso)
          if (response) {
            this.processo = response
            this.search(this.processo.id)
          } else {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar o Processo, verifique o N° do Processo')
          }
        } catch (error) {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar o Processo: ' + error.message)
        }
      }
    },

    async pesquisarComProcesso () {
      this.search(this.processo.id)
    },
    ...mapActions({
      getConversasManutencao: 'conversas/getConversasManutencao'
    }),

    async findConversas (filtro) {
      this.loading = true
      const result = await this.getConversasManutencao(filtro)
      this.conversas = result.conversas
      this.loading = false
      this.totalConversas = result.total
    },

    search (idProcesso) {
      this.filtroPesquisa = idProcesso != null ? { ...this.filtroPesquisa, idProcesso: idProcesso } : this.filtroPesquisa = ''
      this.filtroPesquisa = { ...this.filtroPesquisa, ...this.paginaFiltro }

      this.findConversas(this.filtroPesquisa)
    },

    changePage (newPage) {
      this.paginaFiltro.pagina = newPage - 1
      this.search(this.filtroPesquisa)
    },

    voltar () {
      this.processo = null
      this.numProcesso = ''
      this.conversas = []
      this.totalConversas = 0
    }
  }
}

</script>

<style lang="scss" scoped>
$font-size-small: 12px;
.color-default {
  color: #009d64 !important;
  font-size: 16px;
}
.caixa-pesquisa {
  margin-bottom: 10px;
}
.titulo {
  margin-top: 0;
}
.span-titulo {
  margin-top: 0;
  margin-bottom: 3px;
  font-size: 32px;
  margin-left: 20px;
}
.box-processo {
  min-width: 700px;
  padding-left: 3px;
  padding-right: 3px;
}
.select {
  margin-right: 20px;
  inline-size: 50em;
}
.span-style {
  font-weight: normal;
}
.botao-voltar {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.center {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.box-titulo {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.col-principal {
  width: 100%;
  min-width: 685px;
}
.comunicacao-main {
  padding: 10px 0;
}
.full-width {
  width: 100%;
}
@media (max-width: 780px) {
    .content-comunicacao {
      padding: 10px 0 0 10px;
    }

    .comunicacao-main {
    padding: 20px 20px;
    }

    .listagem-conversas {
      position: relative;
      right: 45%;
    }

    .full-width {
      width: 100%;
      position: relative;
      bottom: 65px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/EncerrarConversa.vue